import { getCookie } from 'utils/cookies';
import platform from 'platform';
import {
  // ARTICLESHOW,
  dimensionMapping,
  dimensionObj,
  // extraKeysMapping,
  grxGlobalValues,
  getNonGlobalGrxValue,
  DEFAULT_GRX_NOT_AVAILABLE,
} from '../../constants';
import { getSignalDataFromLocalStorage } from '../../../src/utils/common';

let popUpCallbacks = null;

const pushNotification = {
  setSignalsInfo() {
    const {
      ClickFromPositionIntegerWithinSlot = -99,
      ClickFromSlotName = 'NA',
      ClickFromPersonalizationAlgorithmName = 'NA',
      ClickFromPixelsFromTop = -99,
      ClickFromTemplate = 'NA',
    } =
      getSignalDataFromLocalStorage() || {};
    const signalsGrxObject = {
      ClickFromPositionIntegerWithinSlot,
      ClickFromSlotName,
      ClickFromPersonalizationAlgorithmName,
      ClickFromPixelsFromTop,
      ClickFromTemplate,
    };
    return signalsGrxObject;
  },
  setUrl() {
    if (typeof window !== 'undefined' && typeof window.grxParams === 'object') {
      window.grxParams.url = window.location.href;
    }
  },
  setssoid() {
    const __ssoid = getCookie('ssoid')
      ? getCookie('ssoid')
      : document.cookie.match(/(?:\\s)?ssoid=(\\w+);?/);
    if (typeof window !== 'undefined' && !!__ssoid) {
      window.grxParams[dimensionMapping.dimension22] = __ssoid;
      window.grxParams[dimensionMapping.dimension21] = 1;
      window.grxParams[dimensionMapping.dimension81] = true;
    } else {
      window.grxParams[
        dimensionMapping.dimension22
      ] = DEFAULT_GRX_NOT_AVAILABLE;
      window.grxParams[dimensionMapping.dimension21] = 0;
      window.grxParams[dimensionMapping.dimension81] = false;
    }
  },
  setPrimeStatus() {
    const __ssoid = getCookie('ssoid')
      ? getCookie('ssoid')
      : document.cookie.match(/(?:\\s)?ssoid=(\\w+);?/);
    const __prc = getCookie('prc')
      ? getCookie('prc')
      : document.cookie.match(/(?:\\s)?prc=(\\w+);?/);
    if (typeof window !== 'undefined' && !!__ssoid) {
      window.grxParams[dimensionMapping.dimension10] =
        __prc && __prc[0] ? __prc[0] : '0';

      if (
        window.sessionStorage &&
        sessionStorage.getItem('inGracePeriod') === 'true'
      ) {
        window.grxParams[dimensionMapping.dimension10] = '5_grace';
      }
    } else {
      window.grxParams[dimensionMapping.dimension10] = '-1';
    }
  },
  setplanName() {
    if (
      typeof window !== 'undefined' &&
      window.sessionStorage &&
      sessionStorage.getItem('planName')
    ) {
      window.grxParams[dimensionMapping.dimension33] = sessionStorage.getItem(
        'planName',
      );
    }
  },
  setPlatformInfo() {
    if (typeof window !== 'undefined') {
      window.grxParams[dimensionMapping.dimension63] = platform.manufacturer
        ? platform.manufacturer
        : DEFAULT_GRX_NOT_AVAILABLE;
      window.grxParams[dimensionMapping.dimension64] = platform.product
        ? platform.product
        : DEFAULT_GRX_NOT_AVAILABLE;
      window.grxParams[dimensionMapping.dimension79] =
        platform.os && platform.os.version
          ? platform.os.version
          : DEFAULT_GRX_NOT_AVAILABLE;
      window.grxParams[dimensionMapping.dimension80] =
        platform.os && platform.os.family
          ? platform.os.family
          : DEFAULT_GRX_NOT_AVAILABLE;
    }
  },
  setGeoDetails() {
    const city = getCookie('geolocation');
    const countryCode = getCookie('geo_country');
    const state = getCookie('grxgeostate');
    window.grxParams[dimensionMapping.dimension82] =
      city || DEFAULT_GRX_NOT_AVAILABLE;
    window.grxParams[dimensionMapping.dimension55] =
      state || DEFAULT_GRX_NOT_AVAILABLE;
    window.grxParams[dimensionMapping.dimension56] =
      countryCode || DEFAULT_GRX_NOT_AVAILABLE;
  },
  setGlobalGrxValues() {
    this.setssoid();
    this.setPrimeStatus();
    this.setPlatformInfo();
    this.setGeoDetails();
    this.setUrl();
    if (
      typeof window !== 'undefined' &&
      typeof window.grxParams === 'object' &&
      typeof window.grx === 'function'
    ) {
      Object.keys(window.grxParams).forEach(grxKey => {
        const grxVal = window.grxParams[grxKey];
        if (grxGlobalValues.includes(grxKey)) {
          window.grx('set', grxKey, grxVal);
        }
      });
    }
  },

  setNonGlobalGrxValues() {
    this.setplanName();
    const nonGlobalValue = getNonGlobalGrxValue();
    const nonGlobalGrxObject = {};
    const gaParams = window.App ? window.App.gaData : {};
    if (!(typeof gaParams !== 'object')) {
      dimensionObj.forEach(grxKey => {
        const grxVal = gaParams[grxKey];
        nonGlobalGrxObject[grxKey] = grxVal;
      });
    }
    if (
      typeof window !== 'undefined' &&
      typeof window.grxParams === 'object' &&
      typeof window.grx === 'function'
    ) {
      Object.keys(window.grxParams).forEach(grxKey => {
        const grxVal = window.grxParams[grxKey];
        if (nonGlobalValue.includes(grxKey)) {
          nonGlobalGrxObject[grxKey] = grxVal;
        }
      });
    }
    return nonGlobalGrxObject;
  },
  showSubscription() {
    return window.Notification.permission === 'default';
  },
  registerWithPopupManager() {
    popUpCallbacks = window.TimesApps.PopUpManager.registerPopup(
      'notification',
      this.initNTFCModule,
    );

    if (popUpCallbacks) {
      popUpCallbacks.onReadyCallback(1);
    }
  },
  bindEvents() {
    if (window.TimesApps && window.TimesApps.PopUpManager) {
      this.registerWithPopupManager();
    } else {
      window.removeEventListener(
        'popUpManagerLoaded',
        this.registerWithPopupManager,
      );
      window.addEventListener(
        'popUpManagerLoaded',
        this.registerWithPopupManager,
      );
    }
  },
  subscribeUser: function subscribeUser(callback) {
    if (
      'serviceWorker' in navigator &&
      window.Notification.permission === 'default'
    ) {
      try {
        if (typeof window.grx_module !== 'undefined') {
          if (typeof window.ntfc_module !== 'undefined') {
            window.ntfc_module.initBrowserPopup(callback);
          }
        }
      } catch (e) {
        console.info('exceptionn', e);
      }
    }
  },
  checkBlockedStatus: function checkBlockedStatus() {
    if (
      'serviceWorker' in navigator &&
      window.Notification &&
      (window.Notification.permission === 'denied' ||
        window.Notification.permission === 'granted')
    ) {
      return false;
      //hide the notification hook if user have alredy blocked or subscribedthe notification
    }
    return true;
  },
  initNTFCModule() {
    if (typeof ntfc_module !== 'undefined') {
      window.ntfc_module.init();
      if (
        popUpCallbacks &&
        typeof popUpCallbacks.onShowCallback === 'function'
      ) {
        // const popUpCallbacks = this.popUpCallbacks.onShowCallback.bind(
        //   window.TimesApps.PopUpManager,
        // );
        popUpCallbacks.onShowCallback(true);
      }
    }
  },
  setGrxValues() {
    window.grxParams = window.grxParams ? window.grxParams : {};
    this.setGlobalGrxValues();
    const nonGlobalGrxObject = this.setNonGlobalGrxValues();
    const signalsGrxObject = this.setSignalsInfo();
    return { nonGlobalGrxObject, signalsGrxObject };
  },
  initializeGrxAndHit() {
    if (typeof window.grx_module !== 'undefined') {
      if (
        !(
          (typeof window !== 'undefined' &&
            window.location.href.indexOf('frmapp=yes') > 0) ||
          (window.geoinfo &&
            (window.geoinfo.Continent === 'EU' ||
              window.geoinfo.CountryCode === 'US'))
        )
      ) {
        if (
          !(
            window.location.href.indexOf('/world') > -1 ||
            window.location.href.indexOf('/business') > -1
          )
        ) {
          if (typeof window.grx_module.triggerGrx === 'function') {
            window.grx_module.triggerGrx();
          }
        }
      }
    } else {
      setTimeout(() => {
        this.initializeGrxAndHit();
      }, 1000);
    }
  },
  init() {
    // const template = data?.template;
    // this.initializeGrxAndHit(template);
  },
};
export default pushNotification;
